import QPMInfo from './QPMInfo'

export default QPMInfo
